import React, { FC } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import {
  DecisionUploadFormLabel,
  DecisionUploadFormError,
} from '../components/DecisionUploadFormComponents';

type Props = {
  value: string;
  hasError: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const DecisionUploadCityField: FC<Props> = ({
  value,
  hasError,
  onChange,
}) => {
  return (
    <>
      <DecisionUploadFormLabel htmlFor="upload-city">
        <FormattedMessage id="upload/decision-upload/components/DecisionUploadCityField.tsx/1" />
      </DecisionUploadFormLabel>
      <input
        id="upload-city"
        value={value}
        className={classNames(hasError && 'is-invalid-input')}
        name="city"
        type="text"
        placeholder="ex : Paris"
        onChange={onChange}
      />
      {hasError && (
        <DecisionUploadFormError>
          <FormattedMessage id="upload/decision-upload/components/DecisionUploadCityField.tsx/2" />
        </DecisionUploadFormError>
      )}
    </>
  );
};
